import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { surveyResponsesStateForSurveyResponseIdSelector } from '../../../reducers/survey-selectors';

import * as Api from '../../../api/api';

export const loadSurveyResponse = (surveyResponseId: number) =>
  createGenericDispatcher<SurveyResponse>({
    name: 'LOAD_SURVEY_RESPONSE',
    loadFunction: () => Api.get(`/survey-responses/${surveyResponseId}`),
    args: { surveyResponseId },
    shouldExecuteSelector: (state: any) =>
      surveyResponsesStateForSurveyResponseIdSelector(state, surveyResponseId),
  });
